export const IconMapPinSingle = (animated = false, isUnavailable = false) => {
  const animationStyle = animated
    ? `
    <style>
      .pin-pulse {
        animation: pinPulse 1.5s ease-in-out infinite;
      }
      @keyframes pinPulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    </style>
  `
    : "";

  const lightColor = isUnavailable ? "#D1D5DB" : "#FDF4A0";
  const darkColor = isUnavailable ? "#9CA3AF" : "#F9E10B";

  return `<svg
    width="50"
    height="47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="${animated ? "pin-pulse" : ""}"
  >
    ${animationStyle}
    <g filter="url(#a)">
      <path
        d="M4 8a8 8 0 0 1 8-8h26a8 8 0 0 1 8 8v23a8 8 0 0 1-8 8H4V8Z"
        fill="${lightColor}"
      />
      <path
        d="M8 12a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v15a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V12Z"
        fill="${darkColor}"
      />
      <path
        d="M20.805 25.412v.99h-1.533L16 12.593V12h1.096c.024 0 .024.017.03.04l2.965 12.7c.036.16.078.259.155.311.06.038.13.056.2.05.014.002.029.002.043 0a.296.296 0 0 1 .223.086.31.31 0 0 1 .093.225ZM31.031 21.178c0 3.419-2.227 5.226-5.03 5.226-2.802 0-5.03-1.805-5.03-5.226 0-3.422 2.229-5.226 5.03-5.226 2.802 0 5.03 1.807 5.03 5.226Zm-5.03 3.704c1.95 0 3.342-1.33 3.342-3.704 0-2.375-1.393-3.704-3.341-3.704-1.949 0-3.342 1.33-3.342 3.704s1.392 3.704 3.34 3.704h.002ZM31.195 25.412v.989h1.533L36 12.594V12h-1.091c-.024 0-.024.017-.03.04l-2.968 12.7c-.036.159-.078.259-.155.31a.333.333 0 0 1-.2.052h-.043a.297.297 0 0 0-.225.084.308.308 0 0 0-.093.226Z"
        fill="#3C2110"
      />
    </g>
    <defs>
      <filter
        id="a"
        x="0"
        y="0"
        width="50"
        height="47"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_147_10496"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_147_10496"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
  `;
};
